module.exports = __webpack_public_path__ + "img/img47.856fbf9d.svg";